/**
 * Format a server-sent ISO reset/resume timestamp as a short local time,
 * e.g. "at 3:47 PM". The instant is computed server-side (tz-correct) and sent
 * on the wire (BudgetNotice.resets_at, or the resets_at field on an /api/offer
 * 402/429 body); the FE only renders it in the viewer's local time.
 *
 * Returns null when the value is missing or unparseable, so callers can choose
 * their own fallback wording instead of showing a wrong/empty time.
 */
export function formatResetTime(iso) {
  if (!iso) return null;
  try {
    const parsed = new Date(iso);
    if (Number.isNaN(parsed.getTime())) return null;
    return `at ${parsed.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
    })}`;
  } catch {
    return null;
  }
}
